import { useWizard } from "react-use-wizard";
import { IFillDataWizardBuy, TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../..";
import EstimateStep from "../../../../../../shared/wizard/steps/estimateStep";
import buySteps from "../buySteps";
import { IDataFormEstimate } from "../../../../../estimate";

interface ISelectionByOwnAppStep_1 {
  onChange: (data: Partial<IFillDataWizardBuy>) => void;
  onChangePrice: (data: number | number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  isNextStepDisabled: boolean;
  dataFormEstimate: Partial<IFillDataWizardBuy>;
}

const SelectionByOwnAppStep_1 = ({
  onChange,
  onChangePrice,
  onReset,
  isNextStepDisabled,
  dataFormEstimate,
}: ISelectionByOwnAppStep_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.step_2);
    onReset(["streetId", "buildingId", "areaInSqM"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.step_2);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        mode="selection"
        onEstimateForm={onChange}
        onEstimatePrice={handleEstimatePrice}
        onNexStep={handleNexStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default SelectionByOwnAppStep_1;
